module.exports = __webpack_public_path__ + "assets/Xi.219f43c940baac3f60fd119a50008771.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/png/packs2x/Xi.png
// module id = 850
// module chunks = 0